
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { format } from 'date-fns';
import { EnrollmentEvent } from '@/services/db/enrollment/types';
import { getEventIcon, getEventTitle, getEventBadgeVariant } from './utils/enrollmentEventUtils';

interface EnrollmentEventItemProps {
  event: EnrollmentEvent;
}

export const EnrollmentEventItem: React.FC<EnrollmentEventItemProps> = ({ event }) => {
  return (
    <div className="border-b pb-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          {getEventIcon(event.eventType)}
          <span className="font-medium">{getEventTitle(event)}</span>
        </div>
        <Badge variant={getEventBadgeVariant(event.eventType)}>
          {event.eventType.replace('_', ' ')}
        </Badge>
      </div>
      
      <div className="mt-2">
        <div className="text-sm text-muted-foreground">
          {format(new Date(event.timestamp), 'PPpp')}
        </div>
        {event.details.notes && (
          <p className="text-sm mt-1">{event.details.notes}</p>
        )}
      </div>
    </div>
  );
};
